import { defineStore } from 'pinia'
import type { Basket } from '~/types/api'

export const useBasketStore = defineStore('basket', () => {
  const { $api } = useApi()
  const basket = ref<Basket | null>(null)
  const count = computed(() => basket.value?.count ?? 0)

  async function refresh() {
    basket.value = await $api<Basket>('/api/basket')
    return basket.value
  }

  // Other tabs refetch when this one changes the basket
  let channel: BroadcastChannel | null = null
  function listen() {
    if (channel || typeof BroadcastChannel === 'undefined') return
    channel = new BroadcastChannel('regotiate-basket')
    channel.onmessage = () => refresh().catch(() => {})
  }
  function announce() {
    listen()
    channel?.postMessage('changed')
  }

  async function add(dealId: number, quantity = 1) {
    basket.value = await $api<Basket>('/api/basket/items', {
      method: 'POST',
      body: JSON.stringify({ deal_id: dealId, quantity }),
    })
    announce()
    return basket.value
  }

  async function setQuantity(itemId: number, quantity: number) {
    basket.value = await $api<Basket>(`/api/basket/items/${itemId}`, {
      method: 'PATCH',
      body: JSON.stringify({ quantity }),
    })
    announce()
  }

  async function remove(itemId: number) {
    basket.value = await $api<Basket>(`/api/basket/items/${itemId}`, { method: 'DELETE' })
    announce()
  }

  function reset() {
    basket.value = null
  }

  return { basket, count, refresh, listen, announce, add, setQuantity, remove, reset }
})
